<template>
  <vs-popup :active.sync="isActive" id="cakeQuestioner">
    <vs-row vs-type="flex" vs-w="12" class="p-0 m-0">
      <vs-button size="large" color="transparent" class="payment-label bg-primary2 text-white w-full"
        icon-pack="feather" icon="icon-pie-chart">
        {{ navigationQuestion.questionText }}
      </vs-button>
    </vs-row>
    <div class="cake-actions-row">
      <vs-button class="cakeAction" @click="navigate" type="gradient" color="success" icon-pack="feather"
        icon="icon-check"></vs-button>
      <vs-button class="cakeAction" @click="moveOn" type="gradient" color="danger" icon-pack="feather" icon="icon-x">
      </vs-button>
    </div>
  </vs-popup>
</template>

<script>
  export default {
    data() {
      return {
        isActive: false,
      }
    },
    methods: {
      navigate() {
        this.isActive = false;
        this.isCakeQuestioned = true;
        this.$store.dispatch("selfservice/hasNeedNavigationByQuestion", true);
      },
      moveOn() {
        this.$emit("moveOn");
        this.isCakeQuestioned = true;
      }
    },
    computed: {
      isCakeQuestioned: {
        get() {
          return this.$store.getters["selfservice/getCakeQuestioned"];
        },
        set(val) {
          this.$store.dispatch("selfservice/setCakeQuestioned", val);
        }
      },
      navigationQuestion() {
        return this.$store.getters["selfservice/getNavigationQuestion"];
      }
    }
  }

</script>

<style>
  #cakeQuestioner .vs-popup .vs-popup--header {
    display: none;
  }

  #cakeQuestioner .vs-popup .vs-popup--content {
    padding: 0 !important;
    margin: 0 !important;
    width: 100%;
  }

  #cakeQuestioner .vs-popup {
    border-radius: 2rem !important;
  }

  /* vs-col mobilde %100'e düşüyordu; flex satırı her zaman yan yana */
  .cake-actions-row {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    gap: 0.75rem;
    padding: 0.5rem 1rem 1rem;
    box-sizing: border-box;
  }

  .cakeAction i {
    font-size: 2rem !important;
  }

  .cakeAction {
    padding: 0;
    width: 5.25rem !important;
    height: 3.5rem !important;
    font-weight: bold !important;
    border-radius: 3.5rem;
  }

</style>
